import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PageLoader from '../components/PageLoader';
import { NAVIGATE_AUTH } from './ConstantRoutes';
const AuthLayout = lazy(() => import('../layout/AuthLayout'));
const LoginPage = lazy(() => import('../pages/Auth/login'));
const LogoutPage = lazy(() => import('../pages/Auth/logout'));
const RegisterPage = lazy(() => import('../pages/Auth/register'));
const Error404 = lazy(() => import('../pages/error/Error404'));


const AuthRoute = () => {
    return (
        <Suspense fallback={<AuthLayout><PageLoader /></AuthLayout>}>
            <Routes>
                <Route path={NAVIGATE_AUTH.LOGIN} element={<AuthLayout><LoginPage /></AuthLayout>} />
                <Route path={NAVIGATE_AUTH.LOGOUT} element={<AuthLayout><LogoutPage /></AuthLayout>} />
                <Route path={NAVIGATE_AUTH.REGISTER} element={<AuthLayout><RegisterPage /></AuthLayout>} />
                <Route path='*' element={<Error404 />}></Route>
            </Routes>
        </Suspense>
    )
}

export default AuthRoute;
